import { Resource as r } from "@coveo/platform-client";
const t = class t extends r {
  /**
   * Returns a paginated list of pipelines for the specified project.
   *
   * @param {string} projectId ID of the project for which to retrieve pipelines.
   * @param {ListPipelinesOptions} options Optional parameters to customize the list of pipelines.
   * @returns {Promise<ListPipelinesReturnVariant<ListPipelinesOptions>>} Paginated list of pipelines for the specified project.
   */
  listPipelinesByProjectId(s, a = {}) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/projects/list`, {
        ...a,
        organizationId: this.api.organizationId,
        projectId: s
      })
    );
  }
};
t.baseUrl = "/rest/search/v1/admin/pipelines";
let i = t;
export {
  i as PipelineInternalResource
};
//# sourceMappingURL=PipelineInternalResource.js.map
